import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Navigation } from "../components/navigation";
import { Header } from "../components/header";
import { Features } from "../components/features";
import { About } from "../components/about";
import { Services } from "../components/services";
import { Gallery } from "../components/gallery";
import { Careers } from "../components/careers";
import { Internship } from "../components/internship";
import { Contact } from "../components/contact";
import JsonData from "../data/data.json";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const Home = () => {
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <>
      <Helmet>
        <title>Giraffic Info World | IT & Software Company in India</title>
        <meta
          name="description"
          content="Giraffic Info World is a leading IT & software company in India offering web development, ERP, SEO, automation and internship programs."
        />
        <link rel="canonical" href={`${BASE_URL}/`} />

        {/* ORGANIZATION SCHEMA */}
        <script type="application/ld+json">
            {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "@id": `${BASE_URL}#organization`,
            "name": "Giraffic Info World",
            "alternateName": "GIW",
            "url": `${BASE_URL}/`,
            "logo": `${BASE_URL}/img/logo.png`,
            "image": `${BASE_URL}/img/logo.png`,
            "description": "Giraffic Info World is a leading IT & software company in India offering web development, ERP, HRMS, SEO, automation and internship programs.",
            "foundingDate": "2022",
            "telephone": "+91-8438144348",

            "address": {
                "@type": "PostalAddress",
                "streetAddress": "No. 21/5, Ramanparambu Road, Opposite Bus Stand",
                "addressLocality": "Thuckalay",
                "addressRegion": "Tamil Nadu",
                "postalCode": "629175",
                "addressCountry": "IN"
            },

            "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+91-8438144348",
                "contactType": "customer support",
                "areaServed": "IN",
                "availableLanguage": ["English", "Tamil"]
            }

            // Add later when available
            // "sameAs": [
            //   "https://www.facebook.com/yourpage",
            //   "https://www.instagram.com/yourpage",
            //   "https://www.linkedin.com/company/yourpage"
            // ]
            })}
        </script>


      </Helmet>

      <Navigation />
      <Header data={landingPageData.Header} />
      <Features data={landingPageData.Features} />
      <About data={landingPageData.About} />
      <Services data={landingPageData.Services} />
      <Gallery data={landingPageData.Gallery} />
      <Internship data={landingPageData.Internship} />
      <Careers data={landingPageData.Careers} />
      <Contact data={landingPageData.Contact} />
    </>
  );
};

export default Home;
